import { TProcedure } from "../../../../utils/types";

export const simulateTabBreastAugImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-1.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-2.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-11.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-4.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-5.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-6.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-7.png",
];

export const simulateTabBreastLiftImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-8.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-9.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-10.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-11.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-12.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-13.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-14.png",
];

export const simulateTabBreastReduxImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-15.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-16.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-17.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-18.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-19.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-20.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-21.png",
];

export const simulateTabBreastLiftPlusAugImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-40.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-9.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-10.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-41.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-12.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-13.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-14.png",
];

export const simulateTabBblImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-22.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-23.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-24.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-25.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-26.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-27.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-28.png",
];

export const simulateTabTummyTuckImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-29.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-30.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-31.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-32.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-33.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-34.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-35.png",
];

export const simulateTabFaceLiftImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-36.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-37.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-38.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-39.png",
];

export const simulateTabLipFillerImages = [
  "https://clinic-os.com/simulation-examples/lip-filler/lip-filler-model-04/source-model.png",
  "https://clinic-os.com/simulation-examples/lip-filler/lip-filler-model-05/source-model.png",
  "https://clinic-os.com/simulation-examples/lip-filler/lip-filler-model-06/source-model.png",
  "https://clinic-os.com/simulation-examples/lip-filler/lip-filler-model-07/source-model.png",
];

export const simulateTabChinLipoImages = [
  "https://clinic-os.com/simulation-examples/chin-liposuction/chin-liposuction-model-01/source-model.png",
  "https://clinic-os.com/simulation-examples/chin-liposuction/chin-liposuction-model-02/source-model.png",
  "https://clinic-os.com/simulation-examples/chin-liposuction/chin-liposuction-model-03/source-model.png",
  "https://clinic-os.com/simulation-examples/chin-liposuction/chin-liposuction-model-04/source-model.png",
];

export const simulateTabRhinoplastyImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Fadamdriver.jpg",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Famy_winehouse_oblique.jpg",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Famy_winehouse_side.jpg",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Fbarbara_streisand_side_view.jpg",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Frhino_blue_side_view.jpg",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Frhino_side_view.webp",
  "https://clinic-os.com/try-our-ai-assets%2Fhead%2Frhino_side_view_2.jpeg",
];

export const simulateTabHairTransplantImages = [
  "https://clinic-os.com/try-our-ai-assets/hair/hair_09.png",
  "https://clinic-os.com/try-our-ai-assets/hair/hair_10.png",
  "https://clinic-os.com/try-our-ai-assets/hair/hair_08.png",
];

export const simulateTabMommyMakeoverImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-51.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-52.png",
];

export const simulateTabAbdomenLipoImages = [
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-53.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-54.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-55.png",
  "https://clinic-os.com/try-our-ai-assets%2Fmodel-56.png",
];

export const simulateTabBreastProcedure: TProcedure[] = [
  "BREAST_AUGMENTATION",
  "BREAST_LIFT",
  "BREAST_REDUCTION",
  "BREAST_LIFT_AND_AUGMENTATION",
];

export const simulateTabBodyProcedure: TProcedure[] = [
  "BBL",
  "TUMMY_TUCK",
  "ABDOMEN_LIPOSUCTION",
];

export const simulateTabFaceProcedure: TProcedure[] = [
  "LIP_FILLER",
  "RHINOPLASTY",
  "CHIN_LIPOSUCTION",
  "HAIR_TRANSPLANT",
];
export const simulateTabMommyMakeoverProcedure: TProcedure[] = [
  "TUMMY_TUCK_AND_BREAST_LIFT",
  "TUMMY_TUCK_AND_BREAST_REDUCTION",
  "TUMMY_TUCK_AND_BREAST_AUGMENTATION",
];
